import React, { useEffect, useRef } from "react";

import ThemedPageWrapper from "./themed-page-wrapper";

const GenericPage = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    const moveContent = () => {
      const existingContent = document.getElementById("wp-content");

      if (
        existingContent &&
        existingContent.firstChild &&
        containerRef.current
      ) {
        // Move children
        while (existingContent.firstChild) {
          containerRef.current.appendChild(existingContent.firstChild);
        }

        existingContent.remove(); // Optionally remove the now-empty element
      } else {
        console.warn("Retrying: existingContent or containerRef not ready");
        requestAnimationFrame(moveContent); // Retry on the next frame
      }
    };

    moveContent();
  }, []);

  return (
    <ThemedPageWrapper>
      <div
        ref={(el) => {
          console.log("Container Ref Assigned:", el);
          containerRef.current = el;
        }}
      />
    </ThemedPageWrapper>
  );
};

export default GenericPage;
